import React, { useState } from 'react';
import CIcon from '@coreui/icons-react';
import { CTooltip } from '@coreui/react';
import ShareReportModal from './ShareReportModal';

const ShareReportButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <CTooltip content="Share Report" trigger="mouseenter">
        <CIcon
          name="cil-share"
          className="ml-3 d-md-down-none"
          onClick={() => setShowModal(true)}
          alt="CoreUI Share Icon"
          style={{ cursor: 'pointer' }}
        />
      </CTooltip>
      <ShareReportModal show={showModal} onClose={() => setShowModal(false)} /> 
    </>
  );
};

export default ShareReportButton;
